import { AvailableOptions, FilterValueTypes, StringFilterOption } from '@access-erp/ui-components';

export const guidFilterOptions: AvailableOptions<FilterValueTypes.StringFilter> = [
  StringFilterOption.Eq,
  StringFilterOption.Ne,
];
